var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,Object.assign({}, _vm.$data,
            {decrementSubscriptionProducts: _vm.decrementSubscriptionProducts,
            incrementSubscriptionProducts: _vm.incrementSubscriptionProducts,
            replaceSubscriptionProducts: _vm.replaceSubscriptionProducts,
            updateSubscription: _vm.updateSubscription}))],2)}
var staticRenderFns = []

export { render, staticRenderFns }